module.exports = __webpack_public_path__ + "static/media/Samira_0.80e65f98.png";